import BaseApi from "../../BaseApi";
import { headers } from "../../ApiSettings";

class Ticketing extends BaseApi {
  constructor() {
    super({ suffix: "" });
  }

  getAdminTickets(params) {
    return this.httpService.get("support/ticket/users", {
      headers,
      params,
    });
  }

  getOneTicketDetails(params) {
    return this.httpService.get("support/ticket", {
      headers,
      params,
    });
  }

  getTicketsStatus(params) {
    return this.httpService.get("support/ticket/status", {
      headers,
      params,
    });
  }

  getTicketAttachment(params) {
    return this.httpService.get("support/attachment-ticket", {
      headers: {
        ...headers,
      },
      responseType: "blob",
      params,
    });
  }

  postTicketMessage(data) {
    let header={...headers, "Content-Type": "multipart/form-data"}
    return this.httpService.post("support/ticket/process", data, {
      headers:header,
    });
  }

  putTicketPending(data) {
    return this.httpService.put("support/Ticket/Pending", data, { headers })
  }

  putTicketClose(data) {
    return this.httpService.put("support/Ticket/Close", data, { headers })
  }

}
const TicketingService = new Ticketing();
export default TicketingService;